import { createContext, useContext } from "react";
import { StoreApi, useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import { BookingCalendarStoreType } from "./booking_calendar_store_types";

export const BookingCalendarContext = createContext<StoreApi<BookingCalendarStoreType> | null>(null);

// eslint-disable-next-line comma-spacing
export const useBookingCalendarStore = <U,>(selector: (state: BookingCalendarStoreType) => U) => {
  const store = useContext(BookingCalendarContext);
  if (!store) {
    throw new Error("Using BookingCalendarContext must be within a BookingCalendarContextProvider");
  }
  return useStore<StoreApi<BookingCalendarStoreType>, U>(store, useShallow(selector));
};

export const useBookingCalendarActions = () => {
  const store = useContext(BookingCalendarContext);
  if (!store) {
    throw new Error("Using BookingCalendarContext must be within a BookingCalendarContextProvider");
  }
  return useStore(store, (state) => state.actions);
};
